<template>
	<div :class="'rounded-card '+(className || '')" v-bind:style="`--borderStyle:${borderStyle}; --innerPadding:${innerPadding}; --titleSize:${titleSize}; --titleColor:${titleColor};`">
		<a :href="url">
			<img :src="thumbnail" alt="Card" />
		</a>
        <h3 v-if="title">{{title}}</h3>
	</div>
</template>
<script type="text/javascript">
	// import helper from './../helpers';

	export default {
		name: 'StaticCard',
		props: ['url','thumbnail','title','className','borderStyle','innerPadding','titleSize','titleColor'],
		data() {
			return {
				events: []
			}
		}
	}
</script>
<style scoped>
	.rounded-card {
        --bgColor: #FFF;
        --borderStyle: 0;
        --innerPadding: 0;
        --titleSize: 16px;
        --titleColor:var(--primaryTextColor);
    }
    
	.rounded-card a, .rounded-card a img {
		width: 100%;
		height: auto;
		display: block;
	}

    .rounded-card a {
        padding: 100% 0 0 0;
        background: var(--bgColor);
        border-radius: 50%;
        border:var(--borderStyle);
        position: relative;
        overflow: hidden;
    }

    .rounded-card a img {
        width: 100%;
        border-style:solid;
        border-width:var(--innerPadding);
        border-color:var(--bgColor);
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
        transition: all 250ms ease;
    }

    .rounded-card a:hover img {
        border-width:0;
    }

    .rounded-card h3 {
        margin: 8px 0;
        text-align: center;
        font-size: var(--titleSize);
    }
</style>